import { createSlice, PayloadAction, } from "@reduxjs/toolkit"
import { REDUX_ACTION_TYPE_PREFIX, } from "app/constants"
import { RootState, } from "app/store"
import { MenuItemType, } from "feature/Menu"
import { mapClient, } from "globalInstance"
import { DEBUG_ENABLE_BLUEDOT, } from "app/env"

const ACTION_TYPE_PREFIX = `${REDUX_ACTION_TYPE_PREFIX}/App`

export const slice = createSlice({
  name: ACTION_TYPE_PREFIX,
  initialState: {
    // 初期化関連のフラグ
    initializing: true as boolean,
    initialized: false as boolean,
    // 選択中のメニュー
    currentMenu: null as MenuItemType | null,
    // 選択中のロケーション
    currentLocationId: null as string | null,
    // 表示中の階数
    currentLevel: 1 as number,
    // 選択中のカテゴリID
    selectedCategory: null as string | null,
    // 位置情報の取得に成功している場合にtrue
    hasUserPosition: false as boolean,
    forceEnableBlueDot: DEBUG_ENABLE_BLUEDOT,
  },
  reducers: {
    initialize: (state) => {
      return {
        ...state,
        initializing: false,
        initialized: true,
      }
    },
    setHasUserPosition: (state, action: PayloadAction<boolean>) => {
      return {
        ...state,
        hasUserPosition: action.payload,
      }
    },
    setCurrentMenu: (state, action: PayloadAction<MenuItemType | null>) => {
      const menu = action.payload
      let selectedCategory = state.selectedCategory
      if (menu === null) {
        selectedCategory = null
      }
      return {
        ...state,
        currentMenu: action.payload,
        selectedCategory,
      }
    },
    setCurrentLocation: (state, action: PayloadAction<string | null>) => {
      return {
        ...state,
        currentLocationId: action.payload,
      }
    },
    setCurrentLevel: (state, action: PayloadAction<number>) => {
      const level = action.payload
      mapClient.setLevel(level)
      return {
        ...state,
        currentLevel: level,
      }
    },
    setSelectedCategory: (state, action: PayloadAction<string | null>) => {
      return {
        ...state,
        selectedCategory: action.payload,
      }
    },
  },
})

export const selectState = (state: RootState) => state.app

export default slice.reducer
